import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'
import { faCheckCircle as faCheckCircleSolid } from '@fortawesome/pro-solid-svg-icons'

import { Box, Link, Text } from '@domain-group/suit-theme'

import type { AttachmentTag } from '@models/types'

import styles from './styles.module.scss'

type TagProps = {
  callbacks: {
    resolveTag: VoidFunction,
  },
  index: number,
  last: boolean,
  tag: AttachmentTag,
}

const Tag = (props: TagProps) => {
  const {
    callbacks: {
      resolveTag,
    },
    index,
    last,
    tag: {
      comment,
      resolved,
    },
  } = props

  return (
    <Box
      alignItems="center"
      borderBottom={last ? 0 : '1px dashed'}
      borderColor="lineColor"
      padding="large"
    >
      <Box
        alignItems="center"
        backgroundColor="blue"
        borderRadius="100%"
        className={styles.count}
        color="white"
        fontWeight="bold"
        height={16}
        justifyContent="center"
        width={16}
      >
        <Text color="white" fontSize="xxsmall" fontWeight="bold">
          {index + 1}
        </Text>
      </Box>

      <Text
        fontSize="small"
        lineHeight="1.3"
        marginX="medium"
        width="calc(100% - 16px - 16px - 14px)"
      >
        {comment}
      </Text>

      <Link textProps={{ color: 'green' }} onClick={resolveTag}>
        <FontAwesomeIcon icon={resolved ? faCheckCircleSolid : faCheckCircle} />
      </Link>
    </Box>
  )
}

export default Tag
